// SortableItem.jsx
import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ListItem, ListItemText } from "@mui/material";

export const SortableItem = ({ client }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: client?.id || "unknown" });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <ListItem ref={setNodeRef} {...attributes} {...listeners} style={style}>
      <ListItemText
        primary={`${client.name}`}
        secondary={client.address || "住所未登録"}
      />
    </ListItem>
  );
};
